module.exports = __webpack_public_path__ + "static/HyperionSide-089bd8eb3a0e76cbcec3501de93a69a8.png";